// extracted by mini-css-extract-plugin
export default {"pieContainer":"styles_pie-container__o1hTL","pieTitle":"styles_pie-title__oGPGT"};